import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import TrustMarquee from "@/components/site/TrustMarquee";
import Services from "@/components/site/Services";
import Trust from "@/components/site/Trust";
import Stats from "@/components/site/Stats";
import { CtaBand, FinalCta } from "@/components/site/Cta";
import About from "@/components/site/About";
import Gallery from "@/components/site/Gallery";
import Reviews from "@/components/site/Reviews";
import Areas from "@/components/site/Areas";
import WhyUs from "@/components/site/WhyUs";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import StickyBar from "@/components/site/StickyBar";
import Admin from "@/components/site/Admin";

const Home = () => {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#FAFAFA] text-slate-900">
      <Header />
      <main>
        <Hero />
        <TrustMarquee />
        <Services />
        <Trust />
        <CtaBand />
        <Stats />
        <About />
        <Gallery />
        <Reviews />
        <Areas />
        <WhyUs />
        <Contact />
        <FinalCta />
      </main>
      <Footer />
      <StickyBar />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}

export default App;
